var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"core_form_box",class:[_vm.classesforAlign,_vm.classesforDirection,_vm.classesforEditable]},[_c('div',{staticClass:"core_form__head fx__border",attrs:{"hidden":_vm.hideTitle}},[_c('div',{staticClass:"slot"},[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"core_form__body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }